var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* 07/09/2020 - Gunavant Jambu

    The class defined here will be responsible for keeping in memory the attributes of selected product
    it will be used across multiple sub projects like ApplyNow and Contact Us. 
    For that, the localStorage class will be used.
	
	Things that will be held in localStorage
	
	 - 
	 - User selected product with quotes

*/
import React, { Component } from "react";

var ProductDetails = function (_Component) {
    _inherits(ProductDetails, _Component);

    /*  static loanType; // string,
      static loanTerm; // int,  
      static productCode; // string
      static loanAmount; //int
      static price; //float
      static rate; // float
      static margin; //int
      static lockPeriod; // int
      static estClosingCost; // int
      static credit; // float
      static apr; // float
      static PI; // float*/

    function ProductDetails(props) {
        _classCallCheck(this, ProductDetails);

        var _this = _possibleConstructorReturn(this, (ProductDetails.__proto__ || Object.getPrototypeOf(ProductDetails)).call(this, props));

        _this.loadSelectedProductData();

        return _this;
    }

    _createClass(ProductDetails, [{
        key: "loadSelectedProductData",
        value: function loadSelectedProductData() {
            /* 
                When the class is loaded make sure get read first from the local storage if nothing is found then set default.
            */
            this.loanType = localStorage.getItem("loanType") || "";
            this.loanTypeCode = localStorage.getItem("loanTypeCode") || "";
            this.loanTerm = localStorage.getItem("loanTerm") || 0;
            this.productCode = localStorage.getItem("productCode") || "";
            this.loanAmount = localStorage.getItem("loanAmount") || 0;
            this.price = localStorage.getItem("price") || 0;
            this.rate = localStorage.getItem("rate") || 0;
            this.margin = localStorage.getItem("margin") || 0;
            this.lockPeriod = localStorage.getItem("lockPeriod") || 0;
            this.estClosingCost = localStorage.getItem("estClosingCost") || 0;
            this.credit = localStorage.getItem("credit") || 0;
            this.apr = localStorage.getItem("apr") || 0;
            this.PI = localStorage.getItem("PI") || 0;
        }
    }, {
        key: "setLoanType",
        value: function setLoanType(loanType) {
            this.loanType = loanType.toUpperCase();

            switch (this.loanType) {
                case "CONVENTIONAL":
                    this.loanTypeCode = "200";
                    this.loanType = "FNMA";
                    localStorage.setItem("loanType", "FNMA");
                    localStorage.setItem("loanTypeCode", this.loanTypeCode);
                    break;
                case "FHA":
                    this.loanTypeCode = "110";
                    localStorage.setItem("loanType", "FHA");
                    localStorage.setItem("loanTypeCode", this.loanTypeCode);
                    break;
                case "VA":
                    this.loanTypeCode = "120";
                    localStorage.setItem("loanType", "VA");
                    localStorage.setItem("loanTypeCode", this.loanTypeCode);
                    break;
                //no default
            }
        }
    }, {
        key: "getLoanType",
        value: function getLoanType() {
            return this.loanType;
        }
    }, {
        key: "setLoanTypeCode",
        value: function setLoanTypeCode(loanTypeCode) {
            this.loanTypeCode = loanTypeCode;
            localStorage.setItem("loanTypeCode", this.loanTypeCode);
        }
    }, {
        key: "getLoanTypeCode",
        value: function getLoanTypeCode() {
            return this.loanTypeCode;
        }
    }, {
        key: "setLoanTerm",
        value: function setLoanTerm(loanTerm) {
            this.loanTerm = loanTerm;
            localStorage.setItem("loanTerm", this.loanTerm);
        }
    }, {
        key: "getLoanTerm",
        value: function getLoanTerm() {
            return this.loanTerm;
        }
    }, {
        key: "getProductCode",
        value: function getProductCode() {
            return this.productCode;
        }
    }, {
        key: "setProductCode",
        value: function setProductCode(productCode) {
            this.productCode = productCode;
            localStorage.setItem("productCode", this.productCode);
        }
    }, {
        key: "getLoanAmount",
        value: function getLoanAmount() {
            return this.loanAmount;
        }
    }, {
        key: "setLoanAmount",
        value: function setLoanAmount(loanAmount) {
            this.loanAmount = loanAmount;
            localStorage.setItem("loanAmount", this.loanAmount);
        }
    }, {
        key: "getPrice",
        value: function getPrice() {
            return this.price;
        }
    }, {
        key: "setPrice",
        value: function setPrice(price) {
            this.price = price;
            localStorage.setItem("price", this.price);
        }
    }, {
        key: "getRate",
        value: function getRate() {
            return this.rate;
        }
    }, {
        key: "setRate",
        value: function setRate(rate) {
            this.rate = rate;
            localStorage.setItem("rate", this.rate);
        }
    }, {
        key: "getMargin",
        value: function getMargin() {
            return this.margin;
        }
    }, {
        key: "setMargin",
        value: function setMargin(margin) {
            this.margin = margin;
            localStorage.setItem("margin", this.margin);
        }
    }, {
        key: "getLockPeriod",
        value: function getLockPeriod() {
            return this.lockPeriod;
        }
    }, {
        key: "setLockPeriod",
        value: function setLockPeriod(lockPeriod) {
            this.lockPeriod = lockPeriod;
            localStorage.setItem("lockPeriod", this.lockPeriod);
        }
    }, {
        key: "getEstClosingCost",
        value: function getEstClosingCost() {
            return this.estClosingCost;
        }
    }, {
        key: "setEstClosingCost",
        value: function setEstClosingCost(estClosingCost) {
            this.estClosingCost = estClosingCost;
            localStorage.setItem("estClosingCost", this.estClosingCost);
        }
    }, {
        key: "getCredit",
        value: function getCredit() {
            return this.credit;
        }
    }, {
        key: "setCredit",
        value: function setCredit(credit) {
            this.credit = credit;
            localStorage.setItem("credit", this.credit);
        }
    }, {
        key: "getApr",
        value: function getApr() {
            return this.apr;
        }
    }, {
        key: "setApr",
        value: function setApr(apr) {
            this.apr = apr;
            localStorage.setItem("apr", this.apr);
        }
    }, {
        key: "getPI",
        value: function getPI() {
            return this.PI;
        }
    }, {
        key: "setPI",
        value: function setPI(PI) {
            this.PI = PI;
            localStorage.setItem("PI", this.PI);
        }
    }]);

    return ProductDetails;
}(Component);

;
export default ProductDetails;